var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "popup",
    {
      staticClass: "confirm-popup",
      attrs: { open: _vm.confirmOpen },
      on: {
        "update:open": function($event) {
          _vm.confirmOpen = $event
        }
      }
    },
    [
      _c("h2", [_vm._v("Confirm")]),
      _vm._v(" "),
      _c("form", { staticClass: "pop-form" }, [
        _c("div", { staticClass: "pf-row split" }, [
          _c("h5", [_vm._v("Are you sure you want to create a New Employee?")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pf-row buttons" }, [
          _c(
            "a",
            {
              staticClass: "pop-btn",
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.confirmOpen = false
                }
              }
            },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "pop-btn",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.createEmployee($event)
                }
              }
            },
            [_vm._v("OK")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }